export const OWA_AUTO_LINKS_CLASSNAME = 'OWAAutoLink';
